import { Box } from '@mui/material';
import './style.scss';

interface FeeColumn {
  fundName: string;
  value: number;
}

interface FeeTableProps {
  headers: string[];
  fees: FeeColumn[];
  showFundNameColumn: boolean;
  fieldName?: string;
  valueField?: string;
  showPercentage?: boolean;
}

export default function FeeTable({ headers, fees, showFundNameColumn = true, fieldName = 'fundName', valueField = 'value', showPercentage = false }: FeeTableProps) {
  const formatValue = (value: number): string => {
    const result = value ? value.toFixed(2) : '0'
    return result;
  };

  return (
    <Box className="fee-table">
      {headers.length === 1 && <h3 className="fee-title" style={{ textAlign: 'center' }}>{headers[0]}</h3>}
      <div className="table-container">
        <table className="fee-data-table">
          {headers.length === 2 && (
            <thead>
              <tr>
                <th className="table-header-cell">{headers[0]}</th>
                <th className="table-header-cell">{headers[1]}</th>
              </tr>
            </thead>
          )}
          <tbody>
            {fees.map((row: any, rowIndex) => (
              <tr key={rowIndex}>
                {showFundNameColumn && (
                  <td className="table-data-cell">
                    {row[fieldName] || ''}
                  </td>
                )}
                <td className="table-data-cell">
                  {formatValue(row[valueField]) || ''}{showPercentage ? '%' : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Box>
  );
}
